// Context con el "entorno" que necesitan las tool cards del agente para
// abrir flujos reales (p. ej. crear/subir un modelo desde el chat):
//   • userId     — id_auth del usuario (webhook procesar_modelo_propio).
//   • companyId  — id_company (guardado del modelo).
//   • shortName / companyName — para prellenar el saludo del mensaje de
//     soporte por WhatsApp (misma fórmula que el resto de la app).
//   • refreshModels — refresca la lista de modelos del padre tras crear uno.
//
// Lo provee InterfazV2 con los valores que ya tiene (userAuthId,
// userCompanyId, shortName, companyName, refreshUserModels).

import { createContext, useContext } from 'react';

export interface AgentEnv {
  userId: string | null;
  companyId: string | null;
  /** Nombre corto del usuario — para el saludo del mensaje de soporte. */
  shortName: string;
  /** Nombre de la marca/empresa — para el saludo del mensaje de soporte. */
  companyName: string;
  refreshModels: () => void;
}

export const AgentEnvContext = createContext<AgentEnv>({
  userId: null,
  companyId: null,
  shortName: '',
  companyName: '',
  refreshModels: () => {},
});

export const useAgentEnv = (): AgentEnv => useContext(AgentEnvContext);
